import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import store from "../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../actions/authentication-actions";
import InputMask from "react-input-mask";
import FormButton from "../../components/form-button";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../components/svg-icon";
import {toast} from "react-toastify";
import InformationToast from "../../components/toast/InformationToast";
import {useSelector} from "react-redux";

const ConversionAuth = () => {

    const {t} = useTranslation()
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const navigate = useNavigate()
    let {secret} = useParams()
    const [showPass, setShowPass] = useState(false)

    useEffect(() => {
        if (authenticated)
            return navigate('/')
    }, [authenticated])
    const handleHide = () => {
        setShowPass(prevState => !prevState)
    }
    const handleChange = (type, value) => {
        setInstance(prevState => ({
            ...prevState,
            [type]: value
        }))
    }


    const [instance, setInstance] = useState({
        otp: '',
        sms: '',
        password: ''
    })
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        associateServices.authConversion({
            secret
        }).then(response => {

            if (response?.status !== 200)
                return navigate('/')

            setLoading(false)
            // if (response?.status === 200) {
            //     store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
            //     navigate('/')
            // } else {
            //     navigate('/')
            // }
        })

    }, [secret])


    const [submitting, setSubmitting] = useState(false)

    const handleComplete = () => {
        console.log('instance = ', instance)


        if (!instance.password || !instance.sms || !instance.otp)
            return toast(<InformationToast
                icon={'ti-x'}
                title={t(`general.information`)}
                message={t(`api-notifications.form-field-cant-be-null`)}
            />)


        setSubmitting(true)
        associateServices.completeAuthConversion({...instance, secret}).then(res => {
            setSubmitting(false)

            if (res?.status !== 200)
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.information`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)


            store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(res?.data))
            // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
            return setSubmitting(false)
        })

    }
    const handleKeyDown = (event) => {

        if (event.key === 'Enter')
            handleComplete()
    }


    if (loading)
        return <Loading/>


    return (

        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="modal-content">
                        <div className="modal__content">
                            <div className="modal__form">

                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t(`general.enter-otp-code-email`)} <b>*</b>
                                    </label>
                                    <InputMask
                                        onKeyDown={handleKeyDown}
                                        mask={'999999'}
                                        maskPlaceholder={null}
                                        className="form__input"
                                        value={instance.otp}
                                        onChange={e => handleChange('otp', e.target.value)}
                                        type="text" // Set type to text
                                        inputMode="numeric" // Hint for numeric keyboard
                                    />
                                </div>


                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t(`general.enter-otp-code-phone`)} <b>*</b>
                                    </label>
                                    <InputMask
                                        onKeyDown={handleKeyDown}
                                        mask={'999999'}
                                        maskPlaceholder={null}
                                        className="form__input"
                                        value={instance.sms}
                                        onChange={e => handleChange('sms', e.target.value)}

                                        type="text" // Set type to text
                                        inputMode="numeric" // Hint for numeric keyboard
                                    />
                                </div>


                                <div className="form__group form__group--pass1">
                                    <label htmlFor="" className="form__label">
                                        {t('register.password')}
                                        <b>*</b>
                                    </label>
                                    <input
                                        onKeyDown={handleKeyDown}
                                        autoComplete={'current-password'}
                                        value={instance?.password}
                                        onChange={e => handleChange('password', e.target.value)}
                                        type={showPass ? 'text' : 'password'}
                                        className="form__input" id="pass1"/>

                                    <button
                                        onClick={handleHide}
                                        className="form__pass" type="button" id="togglePass1">
                                        <SvgIcon id={showPass ? 'eye-hidden' : 'eye-show'}/>
                                    </button>

                                </div>

                                <FormButton
                                    disabled={submitting}
                                    // disabled={true}
                                    loading={submitting}
                                    onClick={handleComplete}
                                    // onClick={null}
                                    label={t('modals.login.sign-up')}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ConversionAuth
